import { Component, OnDestroy, QueryList, ViewChildren } from '@angular/core';
import {
  KENDO_TOOLTIP,
  TooltipDirective,
} from '@progress/kendo-angular-tooltip';
import { Subscription } from 'rxjs';

@Component({
  selector: 'maximizer-disposable-component',
  template: ``,
  imports: [KENDO_TOOLTIP],
})
export class DisposableComponent implements OnDestroy {
  subscriptions: Subscription[] = [];

  @ViewChildren(TooltipDirective)
  public tooltips?: QueryList<TooltipDirective>;

  closeTooltips(): void {
    this.tooltips?.forEach((tooltip) => tooltip.hide());
  }

  addSubscription(subscription?: Subscription): void {
    if (subscription) {
      this.subscriptions.push(subscription);
    }
  }

  unsubscribeAll(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
    this.subscriptions = [];
  }

  ngOnDestroy(): void {
    this.unsubscribeAll();
  }
}
